import React, { createContext, useContext, useEffect, useState } from 'react'
import { STRINGS } from './i18n'

const LangCtx = createContext(null)

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'en'
    return localStorage.getItem('fmc-lang') || 'en'
  })
  const setLang = (next) => {
    setLangState(next)
    try { localStorage.setItem('fmc-lang', next) } catch {}
  }
  useEffect(() => {
    if (typeof document !== 'undefined') document.documentElement.lang = lang
  }, [lang])
  const value = { lang, setLang, t: STRINGS[lang] || STRINGS.en }
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>
}

export function useLang() {
  const ctx = useContext(LangCtx)
  if (!ctx) throw new Error('useLang must be used inside <LangProvider>')
  return ctx
}
